module.exports = __webpack_public_path__ + "img/river.e08031f4.svg";